module.exports = __webpack_public_path__ + "static/media/tip_text_cat_cat_en.41badb82.svg";